var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import OpportunitySourceService from "../../../Services/OpportunitySource.service";
import SearchField from "../../Form/SearchField";
import { OpportunitySourceSearch } from "../../Presentational/OpportunitySource/OpportunitySourceSearch";
const termToRepresentOpportunitySource = "Opportunity Source";
const EditOpportunitySourceModal = (_a) => {
    var { opportunity, currentOpportunitySource, pipelineId, onEdit } = _a, modalProps = __rest(_a, ["opportunity", "currentOpportunitySource", "pipelineId", "onEdit"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { defaultValue: {
            opportunitySource: currentOpportunitySource !== null && currentOpportunitySource !== void 0 ? currentOpportunitySource : undefined,
        }, handleSubmit: (state) => {
            var _a;
            return OpportunitySourceService.bulkUpdateOpportunitySource([opportunity.id], (_a = state.opportunitySource) === null || _a === void 0 ? void 0 : _a.id, pipelineId).then(() => {
                modalProps.onModalClosed();
                if (onEdit) {
                    onEdit(state.opportunitySource
                        ? state.opportunitySource.name
                        : "Unassigned");
                    opportunity.opportunitySource = state.opportunitySource;
                }
            });
        }, modalTitle: `Edit ${termToRepresentOpportunitySource}`, unMountContentWhenClosed: true, children: _jsx(SearchField, { label: "Opportunity Source", name: "opportunitySource", as: (provided) => (_jsx(OpportunitySourceSearch, Object.assign({ active: true }, provided))) }) })));
};
export default EditOpportunitySourceModal;
